import React from "react";
import { Box } from "@components/Box/Box";
import styles from "./styles.module.scss";
import classnames from "classnames";
export interface ContainerProps extends React.ComponentPropsWithoutRef<"div"> {
  variant?: string;
  smallpad?: boolean;
  inside?: boolean;
  insideTop?: boolean;
}

const getContainerVariant = (variant?: string): string => {
  return styles[`container--${variant}`];
};

const Container: React.FC<ContainerProps> = ({
  children,
  className,
  variant,
  smallpad,
  inside,
  ...props
}) => (
  <Box
    className={classnames(
      styles.container,
      variant && getContainerVariant(variant),
      smallpad && styles.containerSmallpad,
      inside && styles.containerInside,
      className && className
    )}
    {...props}
  >
    {children}
  </Box>
);

Container.defaultProps = {};

export { Container };
